import SchoolRecordInput from './SchoolRecordInput'

const AttendanceRecordTable = ({ register, isRead = false }) => {
    return (
        <div>
            <table className='table table-sm table-bordered text-center align-middle' style={{ fontSize: '13px', tableLayout: 'fixed' }}>
                <thead>
                    <tr className='align-middle'>
                        <th rowSpan={2} colSpan={2} style={{ width: '100px' }}>Grade</th>
                        <th rowSpan={2}>School days</th>
                        <th rowSpan={2}>Attendance</th>
                        <th colSpan={3}>Absence</th>
                        <th colSpan={3}>Tardiness</th>
                        <th colSpan={3}>Early Leave</th>
                        <th rowSpan={2} style={{ width: '100px' }}>Remark</th>
                    </tr>
                    <tr className='align-middle'>
                        <th>sick</th>
                        <th>un - <br />excued</th>
                        <th>other</th>
                        <th>sick</th>
                        <th>un - <br />excued</th>
                        <th>other</th>
                        <th>sick</th>
                        <th>un - <br />excued</th>
                        <th>other</th>
                    </tr>
                </thead>

                <tbody>
                    <AttendanceTableRow register={register} grade={10} semester={1} isRead={isRead} hasGrade={true} />
                    <AttendanceTableRow register={register} grade={10} semester={2} isRead={isRead} />

                    <AttendanceTableRow register={register} grade={11} semester={1} isRead={isRead} hasGrade={true} />
                    <AttendanceTableRow register={register} grade={11} semester={2} isRead={isRead} />

                    <AttendanceTableRow register={register} grade={12} semester={1} isRead={isRead} hasGrade={true} />
                    <AttendanceTableRow register={register} grade={12} semester={2} isRead={isRead} />
                </tbody>
            </table>
        </div>
    )
}


const AttendanceTableRow = ({ register, grade, semester, isRead, hasGrade }) => {
    let gradeStr = 'G' + String(grade)
    let semesterStr = semester === 1 ? '1st' : '2nd'

    return (
        <tr>
            {hasGrade && <td rowSpan={2}>{gradeStr}</td>}
            <td>{semesterStr}</td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.schooldays`}
                    isRead={isRead}
                    addClass='w-full'
                />
            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.attendance`}
                    isRead={isRead}
                    addClass='w-full'
                />
            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.absebce.sick`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.absebce.unexcued`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.absebce.other`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.tardiness.sick`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.tardiness.unexcued`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.tardiness.other`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.early.sick`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.early.unexcued`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.early.other`}
                    isRead={isRead}
                    addClass='w-full'
                />

            </td>
            <td>
                <SchoolRecordInput
                    register={register}
                    name={`attendance.grade${grade}.semester${semester}.remark`}
                    isRead={isRead}
                    addClass='w-full'
                />
            </td>
        </tr>
    )
}

export default AttendanceRecordTable